
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { getCSSVariableValue } from "@/assets/ts/_utils";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import SiaranModal from "@/components/modals/forms/SiaranModal.vue";

export default defineComponent({
  name: "butiran-kenaikan",
  components: {SiaranModal},
  props: {
    widgetClasses: String,
    widgetColor: String,
    chartHeight: String,

  },
  methods: {
    batal() {
      Swal.fire({
        title: "KEPASTIAN PEMBATALAN",
        text: "Adakah anda pasti untuk membatalkan permohonan ini?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "PASTI",
        cancelButtonText: "Batal",
      });
    },
  },
  setup(props) {
    const listPengumuman = ref([
      {
        color: "warning",
        icon: "icons/duotune/abstract/abs027.svg",
        title: "Penyelenggaraan Sistem",
        text: "31 Mar 2022",
        number: "+28%",
      },
      {
        color: "success",
        icon: "icons/duotune/art/art005.svg",
        title: "Notis Penutupan Kaunter",
        text: "05 Mar 2022",
        number: "+50%",
      },
      {
        color: "danger",
        icon: "icons/duotune/communication/com012.svg",
        title: "Maklumat Aktiviti Naik Taraf Sistem",
        text: "14 Feb 2022",
        number: "-27%",
      },
      {
        color: "info",
        icon: "icons/duotune/communication/com012.svg",
        title: "Peperiksaan Bayaran Insentif Tugas Kewangan (BITK) Tahun 2022",
        text: "01 Feb 2022",
        number: "+8%",
      },
    ]);
    onMounted(() => {
      setCurrentPageBreadcrumbs("Dashboard Public", ["Public", "Home"]);
    });

    return {
      listPengumuman,
    };
  },
});
